import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-newinstitutionsperyear',
  templateUrl: './newinstitutionsperyear.component.html'
})
export class NewinstitutionsperyearComponent implements OnInit {
  currentYear = new Date().getFullYear();
  yearlist: number[] = [];
  newinstitutionform;
  agedistributionform;

    constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.agedistributionform = this.fb.group({
      year: ['', '']
    });
    
    this.newinstitutionform = this.fb.group({
      year: ['', '']
    });
  }

  populateYearList() {
    while (this.currentYear >= 1884) {
      this.yearlist.push(this.currentYear--);
    }
  }

  addYear() {
  }

  setToYears() {
    this.yearlist.filter
  }
}
